module.exports = __webpack_public_path__ + "static/media/sf-test-12.b4a54d76.mp3";